import * as permissions from 'src/api/permissions'
import {
  GET_ALL_PERMISSIONS,
  SET_PERMISSION,
  SET_PERMISSION_HELPERS
} from 'src/store/mutation-types'

const getAllPermissions = ({commit, dispatch}, params = {}) => {
  dispatch('toggleLoadding', true, {root: true})
  permissions.getAllPermissions(params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_PERMISSIONS, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_PERMISSIONS, [])
    }
  })
}

const setPermission = ({commit}, permission) => {
  commit(SET_PERMISSION, permission)
}

const getAllPermissionsHelpers = ({commit}) => {
  permissions.getAllPermissionHelpers().then(response => {
    commit(SET_PERMISSION_HELPERS, response)
  })
}

export default {
  getAllPermissions,
  setPermission,
  getAllPermissionsHelpers
}



// WEBPACK FOOTER //
// ./src/components/permission/store/actions.js